import React, { useState, useEffect, useCallback } from "react";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Skeleton from "react-loading-skeleton";
import axios from "axios";

const ProjectCard = ({ value, isDarkMode }) => {
  const {
    name,
    description,
    svn_url,
    stargazers_count,
    languages_url,
    pushed_at,
    sitelink,
  } = value;
  return (
    <Col md={6} style={{ margin: "15px 0px" }}>
      <Card
        className={`${
          isDarkMode ? "box-shadow-dark dark-theme-card" : "shadow-lg bg-white"
        } card p-3 mb-10 rounded h-100 m`}
      >
        <Card.Body>
          <Card.Title
            className={`${isDarkMode ? "color-theme-light" : ""}`}
            as="h5"
          >
            {name || <Skeleton />}{" "}
          </Card.Title>
          <Card.Text className={`${isDarkMode ? "color-theme-light" : ""}`}>
            {!description ? "" : description || <Skeleton count={3} />}{" "}
          </Card.Text>
          {svn_url && sitelink ? (
            <CardButtons
              isDarkMode={isDarkMode}
              svn_url={svn_url}
              sitelink={sitelink}
            />
          ) : (
            <Skeleton count={2} />
          )}
          <hr />
          {languages_url ? (
            <Language
              languages_url={languages_url}
              isDarkMode={isDarkMode}
              repo_url={svn_url}
            />
          ) : (
            <Skeleton count={3} />
          )}
          {value ? (
            <CardFooter
              star_count={stargazers_count}
              isDarkMode={isDarkMode}
              repo_url={svn_url}
              pushed_at={pushed_at}
            />
          ) : (
            <Skeleton />
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

const CardButtons = ({ svn_url, isDarkMode, sitelink }) => {
  return (
    <>
      <a
        href={`${svn_url}/archive/master.zip`}
        className={`${
          isDarkMode
            ? "btn-outline-themelight color-theme-light"
            : "btn-outline-secondary"
        } btn mr-4`}
      >
        <i className="fab fa-github" /> Clone
      </a>
      <a
        href={svn_url}
        target=" _blank"
        className={`${
          isDarkMode
            ? "btn-outline-themelight color-theme-light"
            : "btn-outline-secondary"
        } btn mx-4`}
      >
        <i className="fab fa-github" /> Repo
      </a>
      <a
        href={sitelink}
        target=" _blank"
        className={`${
          isDarkMode
            ? "btn-outline-themelight color-theme-light"
            : "btn-outline-secondary"
        } btn`}
      >
        <i className="fas fa-external-link-alt" /> View App
      </a>
    </>
  );
};

const Language = ({ languages_url, isDarkMode, repo_url }) => {
  const [data, setData] = useState([]);

  const handleRequest = useCallback(async () => {
    try {
      const response = await axios.get(languages_url);
      return setData(response.data);
    } catch (error) {
      console.error(error.message);
    }
  }, [languages_url]);

  useEffect(() => {
    handleRequest();
  }, [handleRequest]);

  const array = [];
  let total_count = 0;
  for (let index in data) {
    array.push(index);
    total_count += data[index];
  }

  return (
    <div className={`${isDarkMode ? "color-theme-light" : ""} pb-3`}>
      Languages:{" "}
      {array.length
        ? array.map((language) => (
            <a
              key={language}
              className={`${
                isDarkMode ? "color-theme-light dark-theme-hover" : ""
              } badge badge-light card-link`}
              href={repo_url + `/search?l=${language}`}
              target=" _blank"
            >
              {language}:{" "}
              {Math.trunc((data[language] / total_count) * 1000) / 10} %
            </a>
          ))
        : "code yet to be deployed."}
    </div>
  );
};

const CardFooter = ({ star_count, isDarkMode, repo_url, pushed_at }) => {
  const [updated_at, setUpdated_at] = useState("0 mints");

  const handleUpdatetime = useCallback(() => {
    const date = new Date(pushed_at);
    const nowdate = new Date();
    const diff = nowdate.getTime() - date.getTime();
    const hours = Math.trunc(diff / 1000 / 60 / 60);

    if (hours < 24) {
      if (hours < 1) return setUpdated_at("just now");
      let measurement = hours === 1 ? "hour" : "hours";
      return setUpdated_at(`${hours.toString()} ${measurement} ago`);
    } else {
      const options = { day: "numeric", month: "long", year: "numeric" };
      const time = new Intl.DateTimeFormat("en-US", options).format(date);
      return setUpdated_at(`on ${time}`);
    }
  }, [pushed_at]);

  useEffect(() => {
    handleUpdatetime();
  }, [handleUpdatetime]);

  return (
    <p className="card-text">
      <a
        href={repo_url + "/stargazers"}
        target=" _blank"
        className="text-dark text-decoration-none"
      >
        <span
          className={`${
            isDarkMode ? "color-theme-light" : "text-dark"
          } card-link mr-4`}
        >
          <i className="fab fa-github" /> Stars{" "}
          <span className="badge badge-dark">{star_count}</span>
        </span>
      </a>
      <small className={`${isDarkMode ? "theme-lightgray" : ""} text-muted`}>
        Updated {updated_at}
      </small>
    </p>
  );
};

export default ProjectCard;
